import { AtomField } from 'atoms/form-atoms';
import { TextInput, TextInputProps } from '@carbon/react';
import classNames from 'classnames';
import { useAtomValue, useSetAtom } from 'jotai';
import { NumberFormatValues, NumericFormat } from 'react-number-format';

import style from './number-field.module.scss';
export interface NumberFieldProps extends Omit<
  TextInputProps,
  'value' | 'onChange' | 'defaultValue' | 'labelText'
> {
  field: AtomField<number> | AtomField<number | null>;
  label?: string;
  light?: boolean;
  thousandSeparator?: string | boolean | undefined;
  onChange?: (value: number | null) => void;
  allowNegative?: boolean;
  isAllowed?: (value: number) => boolean;
  suffix?: string;
  prefix?: string;
}
export const NumberField = ({
  field,
  label,
  light,
  thousandSeparator,
  onChange,
  isAllowed,
  suffix,
  prefix,
  ...rest
}: NumberFieldProps) => {
  const setValue = useSetAtom(field);
  const fieldState = useAtomValue(field);
  const thousandSeparatorValue =
    thousandSeparator === false ? undefined : thousandSeparator || ',';
  return (
    <div className={classNames({ [style.light]: light })}>
      <NumericFormat
        {...rest}
        isAllowed={
          isAllowed
            ? (values: NumberFormatValues) => isAllowed(Number(values.value))
            : undefined
        }
        type="text"
        labelText={label || ''}
        thousandSeparator={thousandSeparatorValue}
        suffix={suffix}
        prefix={prefix}
        onValueChange={(values) => {
          const newValue = values.value !== '' ? Number(values.value) : null;
          setValue(newValue);
          onChange?.(newValue);
        }}
        customInput={TextInput}
        invalid={!fieldState.isValid && fieldState.isDirty}
        invalidText={
          !fieldState.isValid && fieldState.isDirty ? fieldState.error : ''
        }
        value={fieldState.value === null ? '' : fieldState.value}
      />
    </div>
  );
};
